export default __webpack_public_path__ + "static/media/mexico.c20ba14e.jpg";